
<template>
    <div class="customervendor-container">
        <ThatsTable title="Colour" ref="table" v-bind:class="{'show-on-table' : showOnWindow}" :endpoint="endpoint" @openModal="openWindow" @deleteYes="DispatchDelete" @openUpdateModal="OpenUpdateModal" :columns="columns">
        </ThatsTable>
        <ColourForm ref="dialogForm" @success="refreshTable" @delete="formDelete"></ColourForm>
    </div>
</template>
<script>
import { mapGetters, mapMutations,mapActions } from 'vuex';
import ColourForm from './ColourForm'
import ThatsTable from '../../components/thats/Table'
export default {
    props : {
        showOnWindow : {
            type :  Boolean,
            default : false,
        }
    },
    data(){
        return {
            endpoint : 'colour/data',
            area : []
        }
    },
    components: {
        ColourForm,
        ThatsTable
    },

    methods: {

        ...mapMutations('ColourModule',[ 'SetFormRecord', 'SetFormStatusUpdate','SetFormStatusCreate']),

        formDelete(record){
            const items = [];
            items.push(record.row);
            this.DispatchDelete(items);
        },
        DispatchDelete(items){
            var self = this;
            self.DeleteRecord(items).then((response) => {
                self.$ThatsNotify.success({
                    message : `(${response.deleted}) record was successfully deleted.`
                })
               self.refreshTable();
            })
            this.closeWindow()
        },
        OpenUpdateModal(obj){

             if(!this.showOnWindow){
                this.SetFormStatusUpdate()
                this.SetFormRecord(obj)
                this.openWindow()
            }else{
                this.$emit('openUpdateModal')
            }
        },
        openWindow(){
            if(!this.showOnWindow){
                
                this.$refs.dialogForm.openDialog()
            }else{
                this.$emit('openModal')
            }
        },
        closeWindow(){
            this.$refs.dialogForm.closeDialog()
        },
        refreshTable(){
            this.$refs.table.refreshTable()
        },

    },
    computed: {
        ...mapGetters('ColourModule',[ 'data', 'page', 'total', 'page', 'length', 'columns', 'Loading', ]),
    },
}
</script>
<style scoped>
.container {
    position: relative;
    min-height: 340px;
  }
  .placement {
    position: absolute;
    right: 0;
  }

  .table-row-input{
      width : 100%;
  }
</style>